import { Controller } from "@hotwired/stimulus"
import { PopupPicker } from "../helpers/popup_picker"

// Populates a TomSelect dropdown from the app's Points Award options JSON
// endpoint - a flat (ungrouped) list, unlike the Trail/TrailStep node-or-
// content picker. Optionally also drives a "+ New Points Award"-style
// popup-window flow (see PopupPicker for the actual popup/overlay/message-
// handling mechanics): when popupUrlValue is set, calling openPopup opens
// a nav-free creation form in a real popup window; on receipt of the new
// record, it's registered as a TomSelect option and selected.
export default class extends Controller {
  static targets = ["select"]

  static values = {
    url: String,
    selected: String,
    popupUrl: String
  }

  async connect() {
    const options = await this.loadOptions()
    this.initTomSelect(options)

    if (this.hasPopupUrlValue) {
      this.popupPicker = new PopupPicker(data => {
        this.tomselect.addOption({ value: data.id, text: data.name })
        this.tomselect.addItem(data.id)
      })
    }
  }

  async loadOptions() {
    try {
      const response = await fetch(this.urlValue)
      return await response.json()
    } catch (error) {
      console.error("Failed to load points award options:", error)
      return []
    }
  }

  get selectElement() {
    return this.hasSelectTarget ? this.selectTarget : this.element
  }

  initTomSelect(options) {
    this.tomselect = new TomSelect(this.selectElement, {
      placeholder: "Search...",
      options: options.map(option => ({ value: option.value, text: option.label })),
      items: this.hasSelectedValue && this.selectedValue ? [this.selectedValue] : []
    })
  }

  openPopup(event) {
    event.preventDefault()
    if (this.popupPicker) this.popupPicker.open(this.popupUrlValue)
  }

  disconnect() {
    if (this.tomselect) {
      this.tomselect.destroy()
    }

    if (this.popupPicker) this.popupPicker.destroy()
  }
}
